export const IDENTIFIERS_LOAD = 'IDENTIFIERS_LOAD';
export const IDENTIFIERS_LOAD_SUCCESS = 'IDENTIFIERS_LOAD_SUCCESS';
export const IDENTIFIERS_LOAD_ERROR = 'IDENTIFIERS_LOAD_ERROR';
export const IDENTIFIER_ADD_SUCCESS = 'IDENTIFIER_ADD_SUCCESS';

// implemented in reducer but does not seems to be used
export const IDENTIFIER_SAVE_SUCCESS = 'IDENTIFIER_SAVE_SUCCESS';

export const IDENTIFIERS_SAVE = 'IDENTIFIERS_SAVE';
export const IDENTIFIERS_SAVE_SUCCESS = 'IDENTIFIERS_SAVE_SUCCESS';
export const IDENTIFIERS_SAVE_ERROR = 'IDENTIFIERS_SAVE_ERROR';

export const IDENTIFIER_DELETE = 'IDENTIFIER_DELETE';
export const IDENTIFIER_DELETE_SUCCESS = 'IDENTIFIER_DELETE_SUCCESS';
export const IDENTIFIER_DELETE_ERROR = 'IDENTIFIER_DELETE_ERROR';

export const IDENTIFIER_DUPLICATE = 'IDENTIFIER_DUPLICATE';
export const IDENTIFIER_DUPLICATE_SUCCESS = 'IDENTIFIER_DUPLICATE_SUCCESS';
export const IDENTIFIER_DUPLICATE_ERROR = 'IDENTIFIER_DUPLICATE_ERROR';

export const IDENTIFIERS_REORDER = 'IDENTIFIERS_REORDER';
export const IDENTIFIERS_REORDER_SUCCESS = 'IDENTIFIERS_REORDER_SUCCESS';
export const IDENTIFIERS_REORDER_ERROR = 'IDENTIFIERS_REORDER_ERROR';
